import { render, staticRenderFns } from "./AromaTabbar.vue?vue&type=template&id=fcca4262&scoped=true"
import script from "./AromaTabbar.vue?vue&type=script&lang=js"
export * from "./AromaTabbar.vue?vue&type=script&lang=js"
import style0 from "./AromaTabbar.vue?vue&type=style&index=0&id=fcca4262&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcca4262",
  null
  
)

export default component.exports